module.exports = __webpack_public_path__ + "media/images/locations/london-4e1a546c9d31202264c4214ea010f3a3.jpg";